import { Table, Tag } from 'antd';
// import { DashboardSociogramContext } from '@BUP/contexts';
import React from 'react';
import { useTranslation } from 'react-i18next';
// import { useHistory } from 'react-router-dom';
import styles from './course-table.module.css';

const CourseTable = ({ data }) => {
  // const history = useHistory();
  // const { filterStudent } = useContext(DashboardSociogramContext);
  const [t] = useTranslation();
  const studentsList = data?.tableResults?.sort((obj1, obj2) => {
    if (obj1.name < obj2.name) {
      return -1;
    }
    if (obj1.name > obj2.name) {
      return 1;
    }
    return 0;
  });

  // const goToStudentProfile = (studentId) => {
  //   console.log('studentId', studentId);
  //   filterStudent(studentsList, studentId);
  //   history.push(`/data/dashboard/student-profile/${studentId}`);
  // };

  const studentsListLength = studentsList?.length.toString();

  const columns = [
    {
      title: (
        <strong className={styles.header_table}>
          {t('pages.data.dashBoardSociogram.tableHeader1')}
        </strong>
      ),
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: (
        <strong className={styles.header_table}>
          {t('pages.data.dashBoardSociogram.tableHeader2')}
        </strong>
      ),
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: (
        <strong className={styles.header_table}>
          {t('pages.data.dashBoardSociogram.tableHeader3')}
        </strong>
      ),
      dataIndex: 'gender',
      key: 'gender',
    },
    {
      title: (
        <strong className={styles.header_table}>
          {t('pages.data.dashBoardSociogram.tableHeader4')}
        </strong>
      ),
      dataIndex: 'popularity',
      key: 'popularity',
      render: (tag) => {
        const color =
          tag === t('pages.data.dashBoardSociogram.level1')
            ? 'cyan'
            : tag === t('pages.data.dashBoardSociogram.level2')
            ? 'green'
            : tag === t('pages.data.dashBoardSociogram.level3')
            ? 'geekblue'
            : tag === t('pages.data.dashBoardSociogram.level4')
            ? 'gold'
            : tag === t('pages.data.dashBoardSociogram.level5')
            ? 'red'
            : 'default';
        return <Tag color={color}>{tag}</Tag>;
      },
    },
    {
      title: (
        <strong className={styles.header_table}>
          {t('pages.data.dashBoardSociogram.tableHeader5')}
        </strong>
      ),
      dataIndex: 'conflict',
      key: 'conflict',
      render: (tag) => {
        const color =
          tag === t('pages.data.dashBoardSociogram.level1')
            ? 'red'
            : tag === t('pages.data.dashBoardSociogram.level2')
            ? 'orange'
            : tag === t('pages.data.dashBoardSociogram.level3')
            ? 'gold'
            : tag === t('pages.data.dashBoardSociogram.level4')
            ? 'green'
            : tag === t('pages.data.dashBoardSociogram.level5')
            ? 'cyan'
            : 'default';
        return (
          <Tag color={color} key={tag}>
            {tag}
          </Tag>
        );
      },
    },
    // {
    //   title: <strong className={styles.header_table}>Detalle</strong>,
    //   dataIndex: 'detail',
    //   key: 'detail',
    // },
  ];

  const courseData = studentsList?.map((student, index) => ({
    key: student?.enrollmentId,
    id: 1,
    name: `${index + 1}. ${student?.name}`,
    email: student?.email,
    gender: student?.gender,
    popularity:
      student?.popularity === 0
        ? t('pages.data.dashBoardSociogram.level6')
        : student?.popularity === 1
        ? t('pages.data.dashBoardSociogram.level5')
        : student?.popularity === 2
        ? t('pages.data.dashBoardSociogram.level4')
        : student?.popularity === 3
        ? t('pages.data.dashBoardSociogram.level3')
        : student?.popularity === 4
        ? t('pages.data.dashBoardSociogram.level2')
        : t('pages.data.dashBoardSociogram.level1'),
    conflict:
      student?.conflictivity === 0
        ? t('pages.data.dashBoardSociogram.level6')
        : student?.conflictivity === 1
        ? t('pages.data.dashBoardSociogram.level5')
        : student?.conflictivity === 2
        ? t('pages.data.dashBoardSociogram.level4')
        : student?.conflictivity === 3
        ? t('pages.data.dashBoardSociogram.level3')
        : student?.conflictivity === 4
        ? t('pages.data.dashBoardSociogram.level2')
        : t('pages.data.dashBoardSociogram.level1'),
    // detail: (
    //   <Button
    //     shape="round"
    //     onClick={() =>
    //       history.push(
    //         `/data/dashboard/student-profile/${student?.enrollmentId}`
    //       )
    //     }
    //   >
    //     Ver más
    //   </Button>
    // ),
  }));

  return (
    <div>
      <Table
        columns={columns}
        dataSource={courseData}
        pagination={{
          defaultPageSize: 5,
          showSizeChanger: true,
          pageSizeOptions: ['5', studentsListLength],
        }}
        align="center"
      />
    </div>
  );
};
export default CourseTable;
